const addToCartButton = document.getElementById("product-add-to-cart");
const is_gift_card = document.getElementById("isGiftCard").value;
const is_subscription = Number(document.getElementById("is_subscription").value) > 0;

const ADD_TO_CART_HINT_ID = "product-add-to-cart-hint";

/**
 * The markup ships `disabled` so the delivery-date requirement survives this script failing to
 * load. Once it has, aria-disabled takes over: the button keeps its place in the tab order and can
 * explain why it is unavailable. Nothing stops a click natively after that, so activation is
 * blocked below instead. The hint only describes the button while it is actually unavailable.
 */
function setAddToCartAvailability(isUnavailable) {
  addToCartButton.disabled = false;
  addToCartButton.setAttribute("aria-disabled", String(isUnavailable));

  if (isUnavailable) {
    addToCartButton.setAttribute("aria-describedby", ADD_TO_CART_HINT_ID);
    return;
  }

  addToCartButton.removeAttribute("aria-describedby");
}

function isAddToCartUnavailable() {
  return addToCartButton.getAttribute("aria-disabled") === "true";
}

// Capture phase, so this runs before the click handlers other scripts bind on the way up.
function blockActivationWhileUnavailable(event) {
  if (!isAddToCartUnavailable()) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}

addToCartButton.addEventListener("click", blockActivationWhileUnavailable, true);
addToCartButton.closest("form")?.addEventListener(
  "submit",
  (event) => {
    if (isAddToCartUnavailable()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

setAddToCartAvailability(!(is_gift_card === "true" || is_subscription === true));

function checkDeliveryDate(input) {
  const Selectors = {
    RECHARGE_WIDGET: '#subscription-widget',
    SELLING_PLAN_RADIO_CHECKED:
      'input[name^="selling_plan_"][type="radio"]:checked',
  };
  if (is_subscription) {
    const selectedPurchaseOption = document.querySelector(`${Selectors.RECHARGE_WIDGET} ${Selectors.SELLING_PLAN_RADIO_CHECKED}`);
    if (!selectedPurchaseOption) {
      setAddToCartAvailability(false);
      return;
    }
    const isOtp = selectedPurchaseOption.value === "onetime" ? true : false;
    if (isOtp) {
      setAddToCartAvailability(input.value.trim() === "");
    } else {
      setAddToCartAvailability(false);
    }
  } else {
    setAddToCartAvailability(input.value.trim() === "");
  }
}

function initializeObserver(input) {
  const observer = new MutationObserver(() => {
    checkDeliveryDate(input);
  });

  observer.observe(input, {
    attributes: true,
    attributeFilter: ["value"],
  });
  checkDeliveryDate(input);
}

function detectElementAdded(selector, callback) {
  const observer = new MutationObserver(() => {
    const element = document.querySelector(selector);
    if (element) {
      observer.disconnect();
      callback(element);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

detectElementAdded('[data-ff-product-calendar][calendar-location="product-template"] input[name="delivery_date_input"]', initializeObserver);
